var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("如何订购商品？")]),_c('div',{staticClass:"content-info"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":"https://img-oss.yunshanmeicai.com/cfile/b999798e8a4e84a7d89eb119720bc470.png","width":"517"}})])])])])
}]

export { render, staticRenderFns }